var _defs, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icons8-file",
    width: 28,
    height: 36,
    viewBox: "0 0 28 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:#fff}.cls-2{fill:#4788c7}.cls-3{fill:#dff0fe}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    d: "M6.5 37.5v-35h18.293l8.707 8.707V37.5z",
    className: "cls-1",
    "data-name": "Path 57",
    transform: "translate(-6 -2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    d: "M24.586 3L33 11.414V37H7V3h17.586M25 2H6v36h28V11l-9-9z",
    className: "cls-2",
    "data-name": "Path 58",
    transform: "translate(-6 -2)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    d: "M24.5 11.5v-9h.293l8.707 8.707v.293z",
    className: "cls-3",
    "data-name": "Path 59",
    transform: "translate(-24 -2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    d: "M25 3.414L32.586 11H25V3.414M25 2h-1v10h10v-1l-9-9z",
    className: "cls-2",
    "data-name": "Path 60",
    transform: "translate(-24 -2)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFile);
export default __webpack_public_path__ + "static/media/icon_file.87169ed92abc239a948a3c6cbf925f84.svg";
export { ForwardRef as ReactComponent };